import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { FALLBACK_LANGUAGE } from "./languages";

import ruCommon from "./locales/ru/common.json";
import ruLogin from "./locales/ru/login.json";
import ruDashboard from "./locales/ru/dashboard.json";
import ruQuestions from "./locales/ru/questions.json";
import ruCover from "./locales/ru/cover.json";
import ruChapter from "./locales/ru/chapter.json";
import ruPhotos from "./locales/ru/photos.json";
import ruOnboarding from "./locales/ru/onboarding.json";

/**
 * Comabooks cabinet is Russian-only. The i18n setup is kept so strings stay
 * in locales/ru/*.json; there is no detection and no language switching.
 * New namespace: add locales/ru/<namespace>.json and register it below.
 */

const resources = {
  ru: { common: ruCommon, login: ruLogin, dashboard: ruDashboard, questions: ruQuestions, cover: ruCover, chapter: ruChapter, photos: ruPhotos, onboarding: ruOnboarding },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: FALLBACK_LANGUAGE,
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: [FALLBACK_LANGUAGE],
    ns: ["common", "login", "dashboard", "questions", "cover", "chapter", "photos", "onboarding"],
    defaultNS: "common",
    returnNull: false,
    interpolation: { escapeValue: false },
  });

export default i18n;
